
import React from 'react';
import { useEffect, useState } from "react";
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import Message from "../tools/Message";
import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import ImmobilisationService from "../../services/ImmobilisationService";
import InventoryService from "../../services/InventoryService";
import { useNavigate } from 'react-router-dom';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Spacer from '../../components/Spacer';

import {
    FormControl,
    Grid,
    TextField,
    Select,
    InputLabel,
    MenuItem,
    Checkbox
} from "@material-ui/core";
import AutocompleteCombobox from '../../components/AutocompleteCombobox';

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

export default function InventoryAffectationSheet(props) {
    const navigate      = useNavigate();    
    const openDialog    = props.open;
    const closeDialog   = props.closeDialog;
    const rows          = props.rows;
    const [dataImmo, setDataImmo] = useState([]);
    const [immoAffectation, setImmoAffectation] = useState([]);
    const [selected, setSelected] = useState([]);

    const [message, setMessage] = useState({
        open: false,
        color: 'green',
        messageInfo: '',
    });
    const { open, color, messageInfo } = message;

    const [form, setForm] = useState({
        user_id: "",
        dir :"",
    });

    const handleCheckboxChange = (id) => (ev) => {
        if(ev.target.checked == true){
            immoAffectation.push(id);
        }
        else{
            immoAffectation.pop(id);
        }

        setImmoAffectation(immoAffectation => [...immoAffectation]);
        localStorage.setItem("immoArrayStorage", immoAffectation);
    };

    function handleCloseMessage() {
        setMessage({ ...message, open: false });
    }

    function handleClickReinit() {
        window.location.reload();
    }

    function handleChangeDir(directionId) {
        setForm({ ...form, dir: directionId });
    }

    function handleChangeUser(personId) {
        console.log("name : " ,personId, "value : ", personId);
        setForm({ ...form, user_id: personId });
        setDataImmo([]);
        setSelected([]);
        localStorage.removeItem("immoArrayStorage");

        InventoryService.getImmoHistoryByDetention(personId).then((result) => {
            if (result.status == true) {
                setDataImmo(result.data);
            }
            else{
                setMessage({
                    ...message,
                    open: true,
                    color: "red",
                    messageInfo: result.message,
                });
            }
        });
    }

    function handleGenerateAffectationSheet() {
        var user_id = form.user_id;
        if(immoAffectation.length == 0){
            alert("Merci de choisir au moins un matériel.");
        }
        else {
            InventoryService.validateImmoAffectationSheet(user_id,immoAffectation).then((result) => {
                if (result.status == true) {
                    InventoryService.generateAffectationSheetPDf(result.data).then((response) => {
                        if(response.data != null){
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const a = document.createElement('a');
                            a.style.display = 'none';
                            a.href = url;
                            const extension = 'pdf';
                            const fileName = 'Fiche_daffectation';
                            
                            const uniqueFileName = `${fileName}_${result.data}.${extension}`;
                            a.download = uniqueFileName;
                            document.body.appendChild(a);
                            a.click();
                            window.URL.revokeObjectURL(url);
                            closeDialog();
                            localStorage.removeItem('immoArrayStorage');
                        }
                        else{
                            alert("Fiche d'affectation non générée car cet utilisateur n'a aucun matériel à afficher!")
                        }
                    })
                    .catch((error) => {
                        console.error('Erreur lors du téléchargement du PDF :', error);
                    });          
                }
                else{
                    
                }
            });
        }
    }
    
    return (
        <div>
            <Message open={open} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />
            <Dialog open={openDialog} onClose={closeDialog} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" maxWidth="lg">
                <DialogTitle id="form-dialog-title" color="primary">{"Fiche d'affectation"}</DialogTitle>
                <DialogContent>
                    {/*
                    <DialogContentText id="alert-dialog-description" style={{fontWeight:"bold",color:'black' }} >
                        {" Informations du détenteur: "}<br /> 
                        Nom du nouveau détenteur:   Jefferson RASOLONOMENJANAHARY <br />
                        Poste :                     Développeur informatique <br />
                        Direction d'affectation:    DG/DPSESI<br />
                    </DialogContentText>
                    */}
                    
                    <AutocompleteCombobox onPersonIdChange={handleChangeUser} onDirectionIdChange={handleChangeDir}/>
                    <Spacer y={2} />
                    
                    <DialogContentText id="alert-dialog-description" style={{fontWeight:"bold",color:'black' }}>
                        {" Informations immobilisation: "}<br />
                    </DialogContentText>
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="left"></TableCell>
                                    <TableCell align="left">Code</TableCell>
                                    <TableCell align="left">Matériel</TableCell>
                                    <TableCell align="left">Date d'acquisition</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {dataImmo.map((row) => (
                                <TableRow key={row.history_id}>
                                    <TableCell>
                                        {/*
                                        <Checkbox
                                            checked={selected.includes(row.history_id)}
                                            onChange={handleCheckboxChange(row.history_id)}
                                        />
                                        */}
                                        <Button>
                                            <input type="checkbox" onChange={handleCheckboxChange(row.history_id)}/>
                                        </Button>
                                    </TableCell>
                                    
                                    <TableCell align="left">{row.code_immo}</TableCell>
                                    <TableCell align="left">{row.name}</TableCell>
                                    <TableCell align="left">{row.date_acquis}</TableCell>
                                </TableRow>
                            ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>

                <DialogActions>                    
                    <Button variant="contained" color="primary" onClick={handleGenerateAffectationSheet}
                    style={{ backgroundColor:"green", color:"#FFFFFF" }}>Télécharger</Button>
                    <Button variant="contained" color="secondary" onClick={closeDialog} >Annuler</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

